// extracted by mini-css-extract-plugin
export default {"container":"RichEditor_container__0Jmv3","saveBtn":"RichEditor_saveBtn__VnD7q"};